module.exports = __webpack_public_path__ + "img/contrology_Website_nav_logo@1x.8f1dbd87.png";